export const BusKey = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  MOBILE: 'mobile',
  FREQUENCY_OF_TRAVEL: 'frequencyOfTravel',
  NO_OF_FREQUENCY: 'numberOfFrequency',
  CLASS: 'class',
  COST: 'cost',
  MODE: 'mode',
  DISTANCE_TRAVELLED: 'distanceTravelled',
  TO: 'travelTo',
  FROM: 'travelFrom',
  STATUS: 'status',
  COMMENT: 'comment'
};
export const BusLabel = {
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  EMAIL: 'Email ID',
  MOBILE: 'Mobile Number',
  FREQUENCY_OF_TRAVEL: 'Frequency of Travel',
  NO_OF_FREQUENCY: 'Number of Frequency',
  CLASS: 'Class',
  COST: 'Cost',
  MODE: 'Mode of Transport',
  DISTANCE_TRAVELLED: 'Distance Travelled',
  TO: 'Travelled To',
  FROM: 'Travelled From',
  STATUS_COMMENTS: 'Status & Comments',
  STATUS: 'Status',
  COMMENT: 'Comment'
};
